import { GoalDto } from '../../../common/dto/goal.dto';
import { CubeRequestConfig } from '../../../common/interface/cube-request-config.interface';

export interface GetSelfGoalSummaryRequestDto {
  goal: GoalDto;
  config: CubeRequestConfig;
}

export interface GetSelfGoalSummariesRequestDto {
  goals: GoalDto[];
  config: CubeRequestConfig;
}
